import React from 'react';
import { Table } from 'antd';

const DataTable = ({ columns, data, rowKey = "_id", loading, pagination, rowSelection, className = "", scroll = { x: 'max-content' }, locale, onRow, rowClassName, expandable }) => {
  return (
    <Table
      className={`custom-table table-container ${className}`}
      rowSelection={rowSelection}
      dataSource={data}
      columns={columns}
      rowKey={rowKey}
      loading={loading}
      locale={locale}
      onRow={onRow}
      expandable={expandable}
      pagination={pagination ? {
        className: "custom-pagination pcu-padding-16",
        showSizeChanger: true,
        showTotal: (total) => <span className="pagination-total">Total {total} items</span>,
        position: ['bottomRight'],
        ...pagination
      } : false}
      bordered={false}
      scroll={scroll}
      rowClassName={rowClassName}
    />
  );
};

export default DataTable;

